module.exports = __webpack_public_path__ + "img/ccompany-honor-MHRA-20231219.44d85631.jpg";